(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';

function _getValueQuantity(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref = valueQuantity || {},
      value = _ref.value,
      unit = _ref.unit;

  if (!value || !unit) {
    return {};
  }

  return "".concat(value, " ").concat(unit);
}

function _mapObservations(observations, panelObservation) {
  var physicalData = {};
  observations.forEach(function (observation) {
    var _ref2 = observation && observation.code || {},
        coding = _ref2.coding;

    var _ref3 = coding && !!coding.length && coding[0] || {},
        code = _ref3.code,
        system = _ref3.system;

    if (!code || !system) {
      return;
    }

    if (!observation.effectiveDateTime) {
      return;
    }

    physicalData.idMap = physicalData.idMap || {};
    physicalData.date = physicalData.date || moment(observation.effectiveDateTime).local().format("ddd, MMM D, YYYY, HH:mm"); // Weight

    if (system === 'http://loinc.org' && code === '29463-7') {
      physicalData.idMap.bodyWeight = observation.id;
      physicalData = Object.assign({}, physicalData, {
        bodyWeight: _getValueQuantity(observation)
      });
    } // Height


    if (system === 'http://loinc.org' && code === '8302-2') {
      physicalData.idMap.bodyHeight = observation.id;
      physicalData = Object.assign({}, physicalData, {
        bodyHeight: _getValueQuantity(observation)
      });
    } // BMI


    if (system === 'http://loinc.org' && code === '39156-5') {
      physicalData.idMap.bmi = observation.id;
      physicalData = Object.assign({}, physicalData, {
        bmi: _getValueQuantity(observation)
      });
    } // Set Physical Data Panel id if it belongs to one


    if (panelObservation && panelObservation.hasMember && panelObservation.hasMember.some(function (hm) {
      return hm.reference === "Observation/".concat(observation.id);
    })) {
      physicalData.idMap.panel = panelObservation.id;
    }
  });

  if (!Object.keys(physicalData).length) {
    return null;
  }

  return physicalData;
}

export default function mapFromFHIR(observationBundleEntry) {
  // Group observations by effectiveDateTime
  var observationsByDateTime = observationBundleEntry.reduce(function (acc, obs) {
    var _ref4 = obs || {},
        resource = _ref4.resource;

    var _ref5 = resource || {},
        effectiveDateTime = _ref5.effectiveDateTime;

    if (!effectiveDateTime) {
      return acc;
    }

    acc[effectiveDateTime] = acc[effectiveDateTime] || [];
    acc[effectiveDateTime].push(resource);
    return acc;
  }, {});
  var physicalDataList = []; // Find physical data panel and add its id into each physical data items (weight, height and bmi)

  Object.values(observationsByDateTime).forEach(function (observations) {
    // Get physical data panels
    var physicalDataPanelObservations = observations.filter(function (obs) {
      var _ref6 = obs && obs.code || {},
          coding = _ref6.coding;

      var _ref7 = coding && !!coding.length && coding[0] || {},
          code = _ref7.code,
          system = _ref7.system; // Vital signs, weight and height panel


      return system === 'http://loinc.org' && code === '34565-2';
    }); // Get individual physical data items (weight, height and bmi) from physical data panel

    physicalDataPanelObservations.forEach(function (physicalDataPanelObservation) {
      var physicalDataObservations = observations.filter(function (obs) {
        return !physicalDataPanelObservation || physicalDataPanelObservation.hasMember.some(function (hm) {
          return hm.reference === "Observation/".concat(obs.id);
        });
      });

      var physicalData = _mapObservations(physicalDataObservations, physicalDataPanelObservation);

      if (!physicalData) {
        return;
      }

      physicalDataList.push(physicalData);
    });
  });
  return physicalDataList;
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_getValueQuantity, "_getValueQuantity", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapObservations, "_mapObservations", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(mapFromFHIR, "mapFromFHIR", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/mappers/mapFromFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();